module.exports = __webpack_public_path__ + "static/media/me_wco.7ac629f2.png";